import { ReactElement, ReactNode } from 'react'
import { Tooltip as MuiTooltip } from '@mui/material'
import classNames from 'classnames'

import { Icon } from '../Icon'

import './index.scss'
export type TooltipOrientation = 'top' | 'bottom' | 'left' | 'right'
export interface TooltipProps {
  children?: ReactNode
  className?: string
  content?: ReactNode
  dark?: boolean
  disabled?: boolean
  mouseEnterDelay?: number
  orientation: TooltipOrientation
  trigger?: ReactElement
}

/**
 * @param content - tooltip body (alternatively pass it as children)
 * @param dark - true if tooltip should implement dark styling
 * @param disabled - true to suppress the tooltip entirely
 * @param mouseEnterDelay - delay in milliseconds for the tooltip to appear
 * @param orientation - side the tooltip should appear
 * @param trigger - React node that should act as the trigger for the tooltip
 */
export const Tooltip = ({
  children,
  className,
  content,
  dark,
  disabled,
  mouseEnterDelay,
  orientation,
  trigger,
}: TooltipProps) => {
  return (
    <MuiTooltip
      title={content ?? children}
      placement={orientation}
      enterDelay={mouseEnterDelay}
      disableHoverListener={disabled}
      disableFocusListener={disabled}
      disableTouchListener={disabled}
      slotProps={{
        tooltip: {
          className: classNames('populus-tooltip', dark && 'dark', orientation, className),
        },
      }}
    >
      {trigger ?? (
        // A button (not a div) so MUI's cloned aria-label lands on a role that permits it,
        // and so keyboard users can focus the icon to open the tooltip.
        <button className="populus-tooltip-icon-container" type="button">
          <Icon
            backgroundColor="black-1"
            backgroundHoverColor="ocean-1"
            component="span"
            hoverColor="ocean-1"
            icon="TooltipSolid"
          />
        </button>
      )}
    </MuiTooltip>
  )
}
